import { render, staticRenderFns } from "./IssueTracker.vue?vue&type=template&id=f6776c02&"
import script from "./IssueTracker.vue?vue&type=script&lang=js&"
export * from "./IssueTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports